var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavRunLocally(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 21.25H3.9375C3.39062 21.25 3 20.8594 3 20.3125C3 19.8047 3.39062 19.375 3.9375 19.375H17.0625C17.5703 19.375 18 19.8047 18 20.3125C18 20.8594 17.5703 21.25 17.0625 21.25ZM9.79688 15.9766L4.79688 10.6641C4.44531 10.2734 4.48438 9.6875 4.83594 9.33594C5.22656 8.98438 5.8125 8.98438 6.16406 9.375L9.5625 12.9688V9.6875V4.6875C9.5625 4.17969 9.95312 3.75 10.5 3.75C11.0078 3.75 11.4375 4.17969 11.4375 4.6875V9.6875V12.9688L14.7969 9.375C15.1484 8.98438 15.7344 8.98438 16.125 9.33594C16.5156 9.6875 16.5156 10.2734 16.1641 10.6641L11.1641 15.9766C10.9688 16.1719 10.7344 16.25 10.5 16.25C10.2266 16.25 9.99219 16.1719 9.79688 15.9766Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavRunLocally);
export default __webpack_public_path__ + "static/media/navRunLocally.65db20e18f56f8e324cd08b750bada4f.svg";
export { ForwardRef as ReactComponent };